import styled from "styled-components";
import { AdminFormSection } from "./AdminFormShared.styles";
import { FlexColumnDiv } from "./common.styles";
export const AdminPasswordSettingsViewParent = styled(FlexColumnDiv) `
    gap: 32px;
`;
export const PasswordFormSection = styled(AdminFormSection) ``;
